import data from "./../../data.json";
import { normalizeVideoFxs } from "../constants";

export const popupComponentDefaultProps = {
  slowControl: 1,
  reverbAmount: 1,
  lowPassCutoff: 1000,
  highPassCutoff: 500,
  bitcrusherMode: false,
  bitcrusherAmount: 0.45,
  bassBoostMode: false,
  bassBoostAmount: 0.5,
  phaserMode: false,
  phaserAmount: 0.5,
  echoMode: false,
  echoAmount: 0.5,
  lofiHissVolume: 1,
  rainyMode: false,
  rainVolume: 0.6,
  coffeeShopMode: false,
  coffeeShopVolume: 0.6,
  seashoreMode: false,
  seashoreVolume: 0.6,
  berghainMode: false,
  berghainVolume: 0.6,
  hotelLoungeMode: false,
  hotelLoungeVolume: 0.6,
  cocktailBarMode: false,
  cocktailBarVolume: 0.6,
  vinylCrackleMode: false,
  vinylCrackleVolume: 0.55,
  preservePitchMode: false,
  speedUpMode: false,
  videoFx: null,
  videoFxs: normalizeVideoFxs(data.videoFxs),
  isSlowedEnabled: false,
  contentApplying: false,
  musicProOnly: false,
  isHeaderVisible: true,
  isPro: false,
  isProFeaturesLocked: false,
  trialMode: false,
  trialEnded: false,
  shareMediaOptIn: false,
  testMode: false,
  paymentHookId: null,
  hookBusy: false,
  hookError: null,
  remainingTrialDays: 0,
  usageAvailable: false,
  usageHit: false,
  usageRemaining: 0,
  usagePeriod: null,
  usageProgress: 0,
  debugMode: false,
  lowPassMode: false,
  highPassMode: false,
  lofiTapeMode: false,
  skin: "color",
  isFeedbackEnabled: false,
  isRateAppEnabled: false,
  isMoodEnabled: true,
  // Footer links ("mood", "skin", "help", "feedback", "studio") a host page leaves out,
  // e.g. Slowed Studio, which has no Pitch Lock, Fast Control or shortcuts.
  hiddenActions: [],
  // On a Slowed Studio tab with nothing playing in it: the gate says to
  // play something there instead of pointing at YouTube.
  studioIdle: false,
  // The dashboard's cap-triggered offer and how many weekly caps this
  // install has hit; together they decide whether the offer is shown.
  usagePromo: null,
  weeklyCapCount: 0,
  nudgePreview: { promo: false, rate: false, update: false },
  // Debug bar only: what a previewed promo CTA reaches, and the last cap
  // notice preview/reset result.
  promoPreviewNote: null,
  capNoticeStatus: null,
  // A one-line, dismissible ask to rate Slowed, shown only to listeners who
  // have had a good run — never at the cap, never on YouTube Music's lock.
  ratePromptVisible: false,
  onRatePromptClick: () => {},
  onRatePromptDismiss: () => {},
  // A one-line note about what a new release brought, with a way to it.
  // Shown after an update to a new release line, never on a fresh install.
  updateBannerVisible: false,
  updateBannerText: "Slowed just updated",
  updateBannerCta: "What’s new",
  // Slowed for any audio file; the off-YouTube link to it shows when set.
  toolUrl: null,
  onOpenToolClick: () => {},
  // The footer's link to Studio; null leaves it out (no address yet, or the
  // panel is on Studio already). See popup/studio-link.js.
  studioUrl: null,
  onStudioClick: undefined,
  // Save, in the Studio sheet: where the song playing here goes into the
  // listener's Studio playlist; null when the page has no song to save.
  studioSaveUrl: null,
  onStudioSaveClick: undefined,
  onUpdateBannerClick: () => {},
  onUpdateBannerDismiss: () => {},
  trackName: null,
  url: null,
  sharingStatus: null,
  onSlowedToggle: () => {},
  onUsageClick: () => {},
  onSlowControlChange: () => {},
  onVideoFxChange: () => {},
  onLowPassModeChange: () => {},
  onLofiTapeModeChange: () => {},
  onSkinChange: () => {},
  onReverbAmountChange: () => {},
  onLowPassCutoffChange: () => {},
  onHighPassModeChange: () => {},
  onHighPassCutoffChange: () => {},
  onBitcrusherModeChange: () => {},
  onBitcrusherAmountChange: () => {},
  onBassBoostModeChange: () => {},
  onBassBoostAmountChange: () => {},
  onPhaserModeChange: () => {},
  onPhaserAmountChange: () => {},
  onEchoModeChange: () => {},
  onEchoAmountChange: () => {},
  onLofiHissVolumeChange: () => {},
  onRainyModeChange: () => {},
  onRainVolumeChange: () => {},
  onCoffeeShopModeChange: () => {},
  onCoffeeShopVolumeChange: () => {},
  onSeashoreModeChange: () => {},
  onSeashoreVolumeChange: () => {},
  onBerghainModeChange: () => {},
  onBerghainVolumeChange: () => {},
  onHotelLoungeModeChange: () => {},
  onHotelLoungeVolumeChange: () => {},
  onCocktailBarModeChange: () => {},
  onCocktailBarVolumeChange: () => {},
  onVinylCrackleModeChange: () => {},
  onVinylCrackleVolumeChange: () => {},
  onPreservePitchModeChange: () => {},
  onSpeedUpModeChange: () => {},
  onAIShuffle: () => {},
  onClearMood: () => {},
  onMoodOpen: () => {},
  onMoodLockedClick: () => {},
  onCopyShareUrl: () => {},
  onCustomizeShortcut: () => {},
  onUpgradeClick: () => {},
  onFeedbackClick: () => {},
  onChangelogClick: () => {},
  onAboutClick: () => {},
  onHelpClick: () => {},
  onRateAppClick: () => {},
  onResetProClick: () => {},
  onUsingUsageClick: () => {},
  onForceMaxUsageClick: () => {},
  onEndTrialModeClick: () => {},
  onShareMediaOptInChange: () => {},
  onTestModeChange: () => {},
  onNudgePreviewChange: () => {},
  onCapNoticePreview: () => {},
  onCapNoticeReset: () => {},
  onRefreshPaymentHookClick: () => {},
  onStartTrialModeClick: () => {},
  onDebugModeChange: () => {},
  billingLoading: false,
  upgradeError: null,
  onResetControls: () => {},
  onManageSubscriptionClick: () => {},
  onOpenYouTubeClick: () => {},
  onEnableSoundCloudClick: () => {},
  hideManagePlan: false,
  selectedMoodName: null,
};
